<template>
  <div class="login-main" style="background-color: #343da9;">
    <!-- :style="{'margin-top':(windowHeight - 636)/2+'px'}" -->
    <div class="content">
      <div class="left">
        <!-- 'margin-left':(200 *((window.innerWidth/1920).toFixed(3))) -->
        <img class="image" :src="login_banner" :style="{'width':banner_width+'px','height':banner_height+'px',}" />
      </div>
      <div class="right">
        <div style="margin-top:200px">
          <label class="title">ETL平台</label>
        </div>
        <div style="margin-top:40px;">
          <label class="loginButton" @click="login">点击登录</label>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.login-main {
  background-color: #343da9;
  width: 100%;
  height: 100%;
  padding-bottom: 100px;
  .content {
    display: flex;
    width: 1200px;
    height: 636px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 15px;
    //  background-color: #bd3636;
    .left {
      width: 900px;
      height: 100%;
      display: flex;
      .image {
        margin-top: 50px;
      }
    }
    .right {
      width: 300px;
      height: 100%;
      align-items: center;
      .title {
        font-weight: 500;
        color: #fff;
        font-size: 72 * 0.65px;
      }
      .loginButton {
        font-weight: 500;
        align-items: center;
        width: 80px;
        height: 25px;
        border-color: #ffffff; //
        border-width: 1px;
        border-style: solid;
        color: #fff;
        font-size: 20px;
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 40px;
        padding-right: 40px;
      }
    }
  }
}
</style>
<script>
import config from "@/js/utils/config";
let Base64 = require("js-base64").Base64;
export default {
  name: "LoginPage",
  data() {
    return {
      windowHeight: window.innerHeight,
      banner_width: 930 * 0.9,
      banner_height: 636 * 0.9,
      login_banner: require("@/assets/login_banner.png")
    };
  },
  mounted() {
    //上报页面数据
    let body = { event_code: "queen_dl", event_name: "登录页" };
    this.CommonSrv.trackEvent(body);
  },
  methods: {
    login() {
      let body = {
        event_code: "all_dl_djdl",
        event_name: "登录页-点击登录"
      };
      this.CommonSrv.trackEvent(body);
      let loginUrl =
        config.api.login + "?next_url=" + Base64.encode(window.location.href);
      window.location.href = loginUrl;
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/js/modules/login/loginpage.vue